import { dialogPageErrorInner } from './dialog';
import { PageErrorView } from './page-error';

export const PageError = PageErrorView;

export const dialogPageError = dialogPageErrorInner;
